<template>
    <div>
    <div v-if="getAxiosRefresh == 3">{{initData()}}</div>
    <div v-if="getTaskPreparedEdit>-1">{{prepareEdit(getTaskPreparedEdit)}}</div>

    <v-layout row wrap v-if="getAxiosRefresh == -1 && myContent">
        <v-expansion-panels
                v-model="panels"
                multiple
                flat
                class="px-6"
            >
        <v-expansion-panel>
            <v-expansion-panel-header><b>Assignment</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-flex xs12>                 
                <v-layout row wrap>               
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1"
                        :class="['card-border-style position-relative overflow-hidden read-only--background read-only--border-color', 
                                (getTaskVertic == true) ? 'rounded-tl-lg rounded-tr-lg':'rounded-tl-lg rounded-bl-lg']">

                            <div v-if="myContent.languages[getShowTaskIndex].permissions && !myContent.islocked" class="universal-row-item__group-btn-panel read-only--border-color">
                                <div class="lang-side">
                                    <img class="lang-side__img" :src="getLanguageIcons[getShowTaskIndex].url" />
                                </div>
                                <v-icon @click="prepareEdit(getShowTaskIndex)" dense>edit</v-icon>
                                <v-icon @click ="clearTranslation(getShowTaskIndex)" dense>delete</v-icon>                                
                                <v-icon v-if="myContent.languages[getShowTaskIndex].visible == 0" @click="changeVisibility(getShowTaskIndex)" dense>visibility_off</v-icon>                                       
                                <v-icon v-else @click="changeVisibility(getShowTaskIndex)" dense>visibility</v-icon>  
                                <v-icon class="border-l read-only--border-color" @click="$store.commit('setShowTaskIndex', -1); $store.commit('setTaskVertic', true)" dense>cancel</v-icon>
                            </div>                         
                            <div v-html="JSON.parse(myContent.languages[getShowTaskIndex].content).content" class="pa-2"></div>
                    </v-flex>

                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1"
                        :class="['card-border-style position-relative overflow-hidden', 
                                (getShowTaskIndex > -1 && getTaskVertic == false) ? 'border-l-none rounded-tr-lg rounded-br-lg':'', 
                                (getShowTaskIndex > -1 && getTaskVertic == true) ? 'border-t-none rounded-br-lg rounded-bl-lg':'', 
                                (getShowTaskIndex > -1) ? '':'rounded-lg']">

                        <div class="universal-row-item__group-btn-panel">
                            <div class="lang-side">
                                <img class="lang-side__img" :src="getLanguageIcons[getEditTaskIndex].url" />
                            </div>

                            <v-menu v-if="getShowTaskIndex > -1" class="lang-wrapper" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none" title="copy parts" dense>
                                    content_copy
                                    </v-icon>
                                </template>
                                    <v-list dense>
                                    <v-list-item-group>
                                        <v-list-item v-for="(copy, index) in copies" :key="index" @click="copyContent(copy.list)"> 
                                            <v-list-item-title>{{copy.name}}</v-list-item-title>
                                        </v-list-item>
                                    </v-list-item-group>
                                    </v-list>
                                </v-menu> 
                            <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save without close" @click="saveData(false, getEditTaskIndex, objectChangePermission?0:1)" dense>save</v-icon>
                            <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save and close" @click="saveData(true, getEditTaskIndex, objectChangePermission?0:1)" dense>check_circle</v-icon>
                            <v-icon title="close without save" @click="closeTask()" dense>meeting_room</v-icon>
                            
                            <v-icon class="border-l" @click="$store.commit('setEditTaskIndex', -1); $store.commit('setTaskVertic', true)" dense>cancel</v-icon>
                        </div>
                        <v-card flat class="pa-2">
                            <quill-editor v-model='tmpContent' :options="getEditorOption()" />  
                        </v-card>
                    </v-flex>                    
                </v-layout>
                </v-flex>
            </v-expansion-panel-content>
        </v-expansion-panel>        
        
        <v-expansion-panel>
            <v-expansion-panel-header><b>Lines to reorder</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap>                      
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                        <div v-html="JSON.parse(myContent.languages[getShowTaskIndex].content).code" class="read-only--background border-all read-only--border-color pa-2 fill-height"></div>
                    </v-flex>
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                        <quill-editor v-model='tmpCode' :options="getEditorOption('basic format for 7')" />                        
                    </v-flex>
                </v-layout> 
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
            <v-expansion-panel-header><b>Help</b></v-expansion-panel-header>
            <v-expansion-panel-content>            
            <v-layout row wrap>                      
                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                    <div v-html="JSON.parse(myContent.languages[getShowTaskIndex].content).help" class="read-only--background border-all read-only--border-color pa-2 fill-height"></div>
                </v-flex>
                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                    <quill-editor v-model='tmpHelp' :options="getEditorOption()" />                        
                </v-flex>
            </v-layout>                        
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>            
            <v-expansion-panel-header><b>Settings</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap>
                    <v-flex xs1>                                                        
                        <v-text-field
                            v-model="myContent.max_score"
                            label="Max score:"
                            outlined
                            :rules="[rules.required, rules.content, rules.size]"
                            :readonly = "!objectChangePermission"
                        ></v-text-field>
                    </v-flex>
                </v-layout>               
            </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>  
        </v-layout>

        <v-layout v-if="myContent && getEditTaskIndex>-1" class="d-flex align-end flex-column border-t mt-5 pa-2">
            <div class="btn-group-a">
                <img class="btn-group-a__divider-item" :src="getLanguageIcons[getEditTaskIndex].url" width="20" />
                <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save without close" @click="saveData(false, getEditTaskIndex, objectChangePermission?0:1)" class="btn-group-a__button btn-group-a__button--green" dense>save</v-icon>
                <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save and close" @click="saveData(true, getEditTaskIndex, objectChangePermission?0:1)" class="btn-group-a__button btn-group-a__button--blue" dense>check_circle</v-icon>
            </div>
        </v-layout>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import * as es from '../../../../assets/editor_settings.js'
import axios from '../../../../axios-auth'
import * as icn from '../../../../assets/task_icons.js'
import * as misc from '../../../../assets/misc.js'

export default {
    data() {
        return {
                myContent: null,
                myGlobals: null,
                task_icons: [],
                tmpContent: '',
                tmpCode: '',
                tmpHelp: '',
                rules: {
                    required: value => !!value || 'Required.',
                    size: value => value > 0 && value < 1000 || 'Out of size.',
                    content: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Invalid value.'
                    }
                },
                copies: [ { name: 'content', list: ['content'] }, // menu content
                          { name: 'lines', list: ['lines'] },
                          { name: 'content, lines', list: ['content', 'lines'] },
                          { name: 'content, help, lines', list: ['content', 'help', 'lines'] },
                ],
                panels : [0]
              }
    },
    props: {
        my_element: Object, 
        objectChangePermission : Boolean
    },
    computed: 
            mapGetters([
                        'getLanguageIcons',
                        'getCountdownStatus',
                        'getShowTaskIndex',
                        'getEditTaskIndex',
                        'getTaskVertic',
                        'getTaskPreparedEdit',
                        'getShowModalMessageResult',
                        'getAxiosRefresh'
                        ])
    ,
    components: {
        quillEditor
    },
    mounted() {
        if (this.getAxiosRefresh !=3 ) this.initData()
    },
    methods: {
        // ************ main methods
        getEditorOption(_version) { return es.getEditorOption(_version) },
        getCmOptions() { return es.getCmOptions('text/html', false) },   
        changeVisibility(_index) {
            this.$store.commit('setTaskNewVisibility', 1 - this.myContent.languages[_index].visible)
            this.$store.commit('setTaskChangeVisibility', true)
            this.myContent.languages[_index].visible = 1 - this.myContent.languages[_index].visible                   
        },
        prepareEdit(_index) {  
            /* eslint-disable no-console */
            // console.log("robim zle")
            this.$store.commit('setTaskPreparedEdit',-1)  
            if (!this.myContent.languages[_index].permissions || this.myContent.islocked) return
            this.$store.commit('setEditTaskIndex', _index)
            this.prepareContent()
        },
        closeTask() { this.$router.go(-1) },

        // ******** end of main methods
        // *********************************

        initData() {
            // this.$store.commit('setFeedback', null)
            this.$store.commit('setAxiosRefresh',-1)
            this.myContent = this.my_element
            this.task_icons = icn.getIcons()

            if (this.$route.params.id == 0) this.myContent.max_score = 10

            if (this.getEditTaskIndex > -1 && (!this.myContent.languages[this.getEditTaskIndex].permissions || this.myContent.islocked)) {
                this.$store.commit('setEditTaskIndex', -1)
                this.$store.commit('setTaskVertic',true)
            }
            if (this.getShowTaskIndex == this.getEditTaskIndex) {
                this.$store.commit('setShowTaskIndex', -1)
                this.$store.commit('setTaskVertic',true)
                this.prepareEdit(this.getEditTaskIndex)
            }                    
            this.prepareContent()   
        },
        prepareContent() {
            if (this.getEditTaskIndex < 0) return
            const _json = misc.getFromJSON(this.myContent.languages[this.getEditTaskIndex].content,'')
            this.tmpContent = ''
            this.tmpHelp = ''
            this.tmpCode = ''
            if (_json != '') {
                this.tmpContent = _json.content
                this.tmpHelp = _json.help
                this.tmpCode = _json.code
            } 
        },
        //******************************************************* */

        copyContent(_list) {
            if (this.getShowTaskIndex > -1) {
                const _json = misc.getFromJSON(this.myContent.languages[this.getShowTaskIndex].content,'')
                if (_json != '') {
                    if (_list.includes('content')) this.tmpContent = _json.content
                    if (_list.includes('help')) this.tmpHelp = _json.help
                    if (_list.includes('lines')) this.tmpCode = _json.code
                }              
            }
        },
        saveData(_close, _index, _only_translation) { 
          if (this.myContent.id == 0 && (this.myContent.course_id === undefined || this.myContent.lesson_id === undefined)) {
              this.$store.commit('setFeedback', 'Data about course and/or lesson is missing')
              return
          }
          this.myContent.max_score = isNaN(this.myContent.max_score) ? 10 : this.myContent.max_score

          const _content = {
              content: this.tmpContent,
              code: this.tmpCode,
              codes: this.getLines(),
              help: this.tmpHelp
          }

         // console.log(_content)

          const _data = {
            task_id: this.myContent.id,
            course_id: this.myContent.course_id, // will be checked on backend
            lesson_id: this.myContent.lesson_id,
            task_type: 'T',
            task_type_id: this.myContent.task_type_id,
            max_score: this.myContent.max_score,
            content: JSON.stringify(_content), // new data
            globals: '',
            lang_id: _index + 1,
            only_translation: _only_translation 
          }

        axios.post('/edit-task', _data, this.$store.getters.getAxiosConfig)
          .then(res => {
            if (res.data.message != 'OK') {
              this.$store.commit('setFeedback', res.data.message)
              return
            } 

            if (this.myContent.id == 0 || this.myContent.task_type_id != this.$route.params.id_type) { // new - refresh                  
                if (this.myContent.id == 0) 
                   this.myContent.id = res.data.task_id
   
                this.$store.commit('setShowTaskIndex', _index)
                this.$store.commit('setEditTaskIndex', _index)

                this.$router.replace({name:'task_edit', params: {
                    id: this.myContent.id,
                    id_type: this.myContent.task_type_id, 
                    show_lang: _index, 
                    edit_lang: _index, 
                    course_id: this.myContent.course_id, 
                    lesson_id: this.myContent.lesson_id
                }})
            } 

            if (_close) this.closeTask()   
            this.$store.commit('setAxiosRefresh', 1)
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)
          }) 
        },
        getLines() {
            var result = misc.hardReplace(this.tmpCode, ' class="ql-syntax" spellcheck="false"', '')
            result = misc.hardReplace(result, '\n', '</pre><pre>')
            result = misc.hardReplace(result, '<pre></pre>','')
            result = misc.hardReplace(result, '<p></p>','')
            result = misc.hardReplace(result, '<p><br></p>','')
            var codes = []
            while (result.indexOf('<pre>')> -1 || result.indexOf('<p>')> -1) {
                let _ps = result.indexOf('<p>')
                let _pres = result.indexOf('<pre>')
                if (((_ps < _pres) && (_ps > -1)) || (_pres == -1)) {
                    let _pe = result.indexOf('</p>',_ps)
                    codes.push("<p>" + result.substring(_ps + 3, _pe) + "</p>")    
                    result = result.substring(0,_ps) + result.substring(_pe+4)
                    continue
                }
                if (((_pres < _ps) && (_pres > -1)) || (_ps == -1)) {
                    let _pree = result.indexOf('</pre>',_pres)
                    codes.push("<pre>"+result.substring(_pres + 5, _pree)+"</pre>")    
                    result = result.substring(0,_pres) + result.substring(_pree+1) // \n  
                }
            }
            return codes
        },        
    }
}
</script>

<style>

</style>

